import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useSettings } from "../../context/SettingsContext";

export default function PublicLayout({ children }) {
  const { pathname } = useLocation();
  const s = useSettings();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => { if (s.seo?.title) document.title = s.seo.title; }, [s]);
  return (
    <div className="min-h-screen flex flex-col bg-[#FCF9F2]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export function PageHero({ title, subtitle, image }) {
  return (
    <div className="relative h-56 md:h-72 flex items-end overflow-hidden">
      <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#2a0f0a]/90 via-[#2a0f0a]/40 to-transparent" />
      <div className="relative max-w-7xl mx-auto px-6 pb-8 w-full animate-fade-up">
        <h1 className="font-display text-3xl md:text-5xl font-extrabold text-white text-shadow-warm">{title}</h1>
        {subtitle && <p className="text-amber-100/90 mt-2 max-w-2xl">{subtitle}</p>}
      </div>
    </div>
  );
}

export function Section({ children, className = "" }) {
  return <section className={`max-w-7xl mx-auto px-6 py-14 md:py-20 ${className}`}>{children}</section>;
}

export function Placeholder({ children }) {
  return (
    <span className="inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide text-amber-700 bg-amber-100 border border-amber-300 rounded px-1.5 py-0.5">
      Placeholder
    </span>
  );
}
